<template>
<div>
	<modal-dialog
		:modal-visible="visible"
		:title="workToDoSummary ? 'Work To Do Summary ' : 'Work Order Summary'"
		modal-size="modal-full"
		cancel-button-text="Done"
		:submit-visible="false"
		v-on:closeModal="closeModal">

		<div v-if="showingSnapshot" class="alert alert-warning">
			This is a historical snapshot of a {{ documentType }}, taken at {{snapshotDateTime}}. <a href="#" v-on:click.prevent="revertToLive">Revert to live version</a>
		</div>

		<template v-if="localService && 'id' in localService">

			<field 
				label="Service #" 
				col-class="col-md-2 col-sm-3" 
				:readonly="true"
				:value="service.job_num">
			</field>

			<field 
				label="Service Name" 
				col-class="col-sm-3 col-md-2" 
				:readonly="true"
				:value="service.job_name">
			</field>

			<field v-if="'Customer' in localService"
				label="Customer" 
				col-class="col-sm-3 col-md-2" 
				:readonly="true"
				:value="localService.Customer.name">
			</field>

			<form-group label="Work Requested" 
				col-class="col-sm-3 col-md-2">

				<div v-html="stripInlineEventHandlers(localService.description)" class="work-requested"></div>
			</form-group>

			<hr>
		</template>

		<div v-if="!workToDoSummary" v-for="entry in mutatedWorksheetEntries" class="work-completed-entry">
			<field 
				label="Date" 
				col-class="col-sm-3 col-md-2"
				:readonly="true"
				:value="formatDateTimeToLocal(entry.updated_at)">
			</field>

			<template v-if="entry.customer_asset_id > 0">
				
				<field 
					label="Asset" 
					col-class="col-sm-3 col-md-2"
					:readonly="true"
					:value="entry.assetName">
				</field>

				<field 
					label="Work Type" 
					col-class="col-sm-3 col-md-2"
					:readonly="true"
					:value="entry.work_type">
				</field>

			</template>

			<form-group 
				label="Work Completed" 
				col-class="col-sm-3 col-md-2">
				<div class="work-completed" v-html="stripInlineEventHandlers(entry.work_completed_description)"></div> 
			</form-group>

			<form-group v-if="entry.tasks && entry.tasks.length > 0" label="Tasks from S.o.V." col-class="col-sm-3 col-md-2">
				<table-list
					:hide-record-count="true"
					record-name="Task"
					:fields="taskFields"
					:records="entry.tasks">
				</table-list>
			</form-group>

			<form-group v-if="entry.serviceTasks && entry.serviceTasks.length > 0" label="Service Tasks" col-class="col-sm-3 col-md-2">
				<table-list
					:hide-record-count="true"
					record-name="Service Task"
					:fields="taskFields"
					:records="entry.serviceTasks">
				</table-list>
			</form-group>

			<form-group v-if="entry.materials && entry.materials.length > 0" label="Materials" col-class="col-sm-3 col-md-2">
				<table-list
					:hide-record-count="true"
					record-name="Material"
					:fields="partsFields"
					:records="entry.materials">
				</table-list>
			</form-group>

			<form-group v-if="entry.equipment && entry.equipment.length > 0" label="Equipment" col-class="col-sm-3 col-md-2">
				<table-list
					:hide-record-count="true"
					record-name="Equipment Item"
					:fields="equipmentFields"
					:records="entry.equipment">
				</table-list>
			</form-group>
			<hr>
		</div>

		<div class="row">
			<div class="col-md-6">

				<field v-if="!workToDoSummary && totalLabourValues"
					label="Total Labour" 
					col-class="col-sm-6 col-md-4"
					:readonly="true"
					:value="totalLabourValues">
				</field>

				<form-group v-if="!hideSig" label="Client Signature" col-class="col-sm-6 col-md-4">
					<div class="d-flex flex-row">
						<signature-field v-model="signature" v-on:input="takeSnapshot" :readonly="showingSnapshot"></signature-field>
					</div>
				</form-group>
			</div>

			<div class="col-md-6" >
				<button v-if="snapshots.length > 0 && !showingSnapshot" class="btn btn-light" v-on:click="snapshotsModalVisible = true">
					<i class="fa fa-clock"></i>
					View Signing History
				</button>

				<div v-if="summaryPDFUrl && snapshotId" class="mt-2">
					<a :href="summaryPDFUrl" class="btn btn-light mr-2">
						<i class="fa fa-file-pdf"></i>
						Download Signed Summary as PDF
					</a>

					<button type="button" class="btn btn-success" v-on:click="sendSummaryByEmail">
						<i class="fa fa-paper-plane"></i>
						Send by Email
					</button>
				</div>
			</div>
		</div>

		<div v-if="showingSnapshot" class="alert alert-warning">
			This is a historical snapshot of a {{ documentType }}, taken at {{snapshotDateTime}}. <a href="#" v-on:click.prevent="revertToLive">Revert to live version</a>
		</div>

		<!--<table-list
			record-name="Material"
			:records=""
			:fields="">
		</table-list>-->


	</modal-dialog>

	<send-document-modal
		:visible="sendModal.visible"
		document-type="Work Order Summary"
		:customer="customer"
		:employees="$store.users"
		v-on:send="confirmSendSummary"
		v-on:closeModal="sendModal.visible = false">
	</send-document-modal>

	<modal-dialog :modal-visible="snapshotsModalVisible"
		title="View Signing History"
		cancel-button-text="Done"
		:submit-visible="false"
		v-on:closeModal="snapshotsModalVisible = false">

		<table-list
			record-name="Snapshot"
			:fields="[
				{label: 'Date',key:'createdAt'},
				{label: 'Signed By',key:'signatureName'},
				{label: 'Service Status',key: 'serviceStatus'}
			]"
			:records="mutatedSnapshots"
			:has-edit="true"
			edit-button-text="View"
			:clickable-row="true"
			v-on:edit="viewSnapshot">
		</table-list>

	</modal-dialog>
</div>
</template>
<script type="text/javascript">
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import TableList from "@/components/TableList"
import SignatureField from "@/components/SignatureField"

import SendDocumentModal from "@/components/SendDocumentModal"

import ServiceMixins from "@/mixins/ServiceMixins.js"
import ContactMixins from "@/mixins/ContactMixins.js"

export default {
	name: "WoSummary",
	components: {
		ModalDialog,
		Field,
		FormGroup,
		TableList,
		SignatureField,
		SendDocumentModal
	},
	mixins: [ServiceMixins,ContactMixins],
	props: [
		"visible",
		"service",
		"changeOrder",
		"workCompletedEntries",
		"workToDoSummary",
		"hideSig",
		
	],
	data() {
		return {
			showingSnapshot: false,
			snapshotDateTime: null,
			localService: null,
			localChangeOrder: null,
			localWorkCompletedEntries: null,
			timeLogs: [],
			signature: null,
			compiledEquipment: [],
			compiledTasks: [],
			compiledMaterials: [],
			compiledWorkCompleted: "",
			snapshotId: null,
			snapshots: [],
			customer: false,
			snapshotsModalVisible: false,
			attachedAssets: [],
			sendModal: {
				visible: false,
				recipients: [],
				additionalRecipients: "",
				working: false
			}
		}
	},
	watch: {
		visible() {
			this.revertToLive()  // "clear" model on opening
		},
		workCompletedEntries() {
			this.compileAssets()

			this.localWorkCompletedEntries = this.workCompletedEntries
		},
		service() {
			this.localService = this.service
			this.localWorkCompletedEntries = this.workCompletedEntries
		},
		changeOrder() {
			this.localChangeOrder = this.changeOrder
			this.localWorkCompletedEntries = this.workCompletedEntries
		},
		localService() {
			if (this.localService && "id" in this.localService) {
				this.fetchSnapshotHistory()
			}
		},
		localChangeOrder() {
			if (this.localChangeOrder && "id" in this.localChangeOrder)
				this.fetchSnapshotHistory()
		},
		localWorkCompletedEntries() {
			if (this.service)
				this.fetchAttachedAssets()
		},
		visible() {
			this.signature = null
		}
	},
	computed: {
		documentType() {
			if (this.localService)
				return "service"
			else
				return "change order"
		},
		mutatedSnapshots() {
			let vm = this
			return this.snapshots.map(snapshot => {
				snapshot.signatureName = ""
				snapshot.serviceStatus = ""

				let snapshotObj = {}
				try {
					snapshotObj = JSON.parse(snapshot.snapshot_json)

					snapshot.signatureName = snapshotObj.signature.name
					snapshot.serviceStatus = snapshotObj.service.status
				}
				catch (ex) {}

				snapshot.createdAt = vm.formatDateTimeToLocal(snapshot.created_at)
				
				return snapshot
			})
		},
		summaryPDFUrl() {
			if (this.snapshotId) {
				if (this.documentType == 'service')
					return window.apiBase+"ServiceSnapshot/pdf?id="+this.snapshotId+"&token="+this.$store.sessionToken+"&download=true"
				else
					return window.apiBase+"ChangeOrderSnapshot/pdf?id="+this.snapshotId+"&token="+this.$store.sessionToken+"&download=true" 
			}

			else return false
		},
		mutatedWorksheetEntries() {
			let vm = this, entries
			if (this.localWorkCompletedEntries) {
				return this.localWorkCompletedEntries.map(entry => {
					entry.equipment = []
					entry.tasks = []
					entry.materials = []

					try {
						entry.materials = JSON.parse(entry.parts_used_json)
					}
					catch (e) {}

					try {
						entry.equipment = JSON.parse(entry.equipment_used_json)

						entry.equipment = entry.equipment.map(eq => {
							eq.qtyWithUnit = eq.qty + " " + eq.qty_unit

							return eq
						})
					}
					catch (e) {}

					entry.equipment = entry.equipment.map(eq => {
						let qty = 0
						if ("qty" in eq)
							qty = eq.qty
						else if ("hrs" in eq) {
							qty = eq.hrs
						}

						if ("unit" in eq) {
							if (eq.unit == 'hrs')
								eq.qty_unit = 'hours'
							else
								eq.qty_unit = eq.unit
						}
						else if (!("qty_unit" in eq)) {
							eq.qty_unit = "hours"
						}

						eq.qtyWithUnit = qty + " " + eq.qty_unit

						return eq
					})

					try {
						entry.tasks = JSON.parse(entry.tasks_completed_json)
					}
					catch (e) {}

					try {
						entry.serviceTasks = JSON.parse(entry.service_tasks_completed_json)
					}
					catch (e) {}

					entry.assetName = ""
					if ("customer_asset_id" in entry && entry.customer_asset_id > 0) {
						let asset = vm.attachedAssets.find(theAsset => theAsset.id == entry.customer_asset_id)
						if (asset) {
							entry.assetName = asset.description + " (S/N " + asset.serial_num + ")"
							entry.CustomerAsset = asset
						}
					}

					return entry
				})
			}
			else
				return []
		},
		totalLabourValues() {
			let reg=  0, ot = 0

			if (this.localService) {
				reg = +this.localService.summary_total_hours
				ot = +this.localService.summary_total_hours_ot
			}
			if (this.localChangeOrder) {
				reg = +this.localChangeOrder.summary_total_hours
				ot = +this.localChangeOrder.summary_total_hours_ot
			}

			let value = ""

			if (reg !== 0) {
				reg = reg.toFixed(2)

				value = "Reg: " + reg + " hrs"
			}
			if (ot !== 0) {
				ot = ot.toFixed(2)

				value += ", OT: " + ot + " hrs"
			}

			return value
		}
	},
	methods: {
		compileAssets() {
			let vm = this

			let compiled = this.joinWorksheets(this.localWorkCompletedEntries)

			this.compiledEquipment = compiled.equipment
			this.compiledMaterials = compiled.materials
			this.compiledTasks = compiled.tasks
			this.compiledWorkCompleted = compiled.description
		},
		closeModal() {
			this.$emit("closeModal")
		},
		viewSnapshot(snapshot) {
			this.showingSnapshot = true
			this.snapshotDateTime = this.formatDateTimeToLocal(snapshot.created_at)

			this.snapshotId = snapshot.id

			let snapshotObj = {}
			try {
				let obj = JSON.parse(snapshot.snapshot_json)
				if ("service" in obj) {
					snapshotObj =  obj.service
					this.localService = snapshotObj
					this.localWorkCompletedEntries = snapshotObj.ServiceWorksheet
				}
				else if ("changeOrder" in obj) {
					snapshotObj = obj.changeOrder
					this.localChangeOrder = snapshotObj
					this.localWorkCompletedEntries = snapshotObj.ChangeWorksheet
				}

				this.signature = obj.signature
			}
			catch (e) {}

			this.snapshotsModalVisible = false
		},
		revertToLive() {
			this.showingSnapshot = false
			this.signature = false
			this.localService = this.service
			this.localChangeOrder = this.changeOrder
			this.localWorkCompletedEntries = this.workCompletedEntries
			this.snapshotId = null

			this.$forceUpdate()
		},
		takeSnapshot() {
			let vm = this

			let payload = {}, resource

			if (this.localService) {
				this.localService.ServiceWorksheet = this.workCompletedEntries
				payload.service_id = this.localService.id
				payload.snapshot_json = JSON.stringify({
					service: this.localService,
					signature: JSON.parse(this.signature) //because this is already json
				})
				resource = "ServiceSnapshot"
			}
			else if (this.localChangeOrder) {
				this.localChangeOrder.ChangeWorksheet = this.workCompletedEntries
				payload.change_order_id = this.localChangeOrder.id
				payload.snapshot_json = JSON.stringify({
					changeOrder: this.localChangeOrder,
					signature: JSON.parse(this.signature)
				})
				resource = "ChangeOrderSnapshot"
			}



			if (this.workToDoSummary)
				payload.is_work_requested = 1

			this.saveRecord(resource,payload,response => {
				if (response.success) {
					vm.alertSaved("Summary saved!")
					vm.snapshotId = response.record_id
					vm.fetchSnapshotHistory()
				}
			})
		},
		sendSummaryByEmail() {
			let vm = this

			if (!this.customer)
				this.fetchCustomer()

			if (!this.$store.users || this.$store.users.length == 0)
				this.fetchUsers(false,false,["id","slug","email","first_name","last_name"])

			if (!this.customer) {
				this.sendModal.working = true
				this.fetchCustomer().then(response => {
					vm.sendModal.working = false
					this.sendModal.visible = true
				})
			}
			else
				this.sendModal.visible = true


			this.sendModal.visible = true
		},
		confirmSendSummary(modalPayload) {
			let vm = this

			vm.sendModal.working = true

			let additional = modalPayload.additional

			let employees = modalPayload.employeeRecipients.map(id => {
				let emp = vm.$store.users.find(user => user.id == id)

				if (emp)
					return emp.email

				return null
			})

			additional += ","+employees.join(",")

			let payload = {
				additional,
				recipients: modalPayload.recipients,
				id: vm.snapshotId
			}

			this.postData("ServiceSnapshot/send",payload,true).then(response => {
				if (response.success) {
					vm.alertSuccess("Work Order Summary sent!")
					
					vm.sendModal.visible = false
				}
			})
		},
		fetchCustomer() {
			let vm = this

			let params = {
				include: ["Contact"]
			}

			let customerId
			if (this.localService && "customer_id" in this.localService)
				customerId = this.localService.customer_id
			else if (this.$store.project && "customer_id" in this.$store.project.customer_id)
				customerId = this.$store.project.customer_id

			return new Promise((resolve,reject) => {

				if (customerId) {
					vm.getJSON("Contact/find/"+customerId,params).then(response => {
						if (response.success)
							vm.customer = response.data
						
						resolve(response)
					})
				}
				else
					resolve(false)
			})
		},
		fetchAttachedAssets() {
			let vm = this

			let assetIds = this.mutatedWorksheetEntries.map(entry => entry.customer_asset_id)

			let params = {
				filters: [
					["id",assetIds]
				],
				include: ['Checklist']
			}

			this.getJSON("CustomerAsset/get",params).then(response => {
				if (response.success)
					vm.attachedAssets = response.data
			})
		},
		fetchSnapshotHistory() {
			let vm = this

			console.log("fetchSnapshotHistory")

			let filters = false, resource

			if (this.localService && "id" in this.localService) {
				filters = [["service_id",this.localService.id]]
				resource = "ServiceSnapshot"
			}
			if (this.localChangeOrder && "id" in this.localChangeOrder) {
				filters = [["change_order_id",this.localChangeOrder.id]]
				resource = "ChangeOrderSnapshot"
			}

			let params = {
				filters
			}

			return new Promise((resolve,reject) => {
				if (resource) {
					vm.getJSON(resource + "/get",params).then(response => {
						if (response.success) 
							vm.snapshots = response.data

						resolve(response)
					})
				}
				else
					resolve(false)
			})
		}
	},
	created() {
		this.localService = this.service
		this.localChangeOrder = this.changeOrder
		this.localWorkCompletedEntries = this.workCompletedEntries

		if ((this.localService && "id" in this.localService) || (this.localChangeOrder && "id" in this.localChangeOrder)) {
			this.fetchSnapshotHistory()

			if (this.localService && "id" in this.localService)
				this.fetchAttachedAssets()
		}
	}
}
</script>

<style type="text/css" scoped>
	.work-completed, .work-requested {
		padding: 10px;
		box-shadow: inset 0 0 4px #efefef;
		background-color: #f8f9fa;
		border: 1px solid #ced4da;
		word-wrap: break-word;
		white-space: pre-wrap;
	}
</style>